@if (loading$()) {
  @for (row of rows$(); track groupIndex; let groupIndex = $index) {
    <div [class]="row.rowClass">
      @for (cell of row.cells; track cellIndex; let cellIndex = $index) {
        <div [class]="cell.cellClass" [ngStyle]="{ opacity: cell.opacity }"></div>
      }
    </div>
  }
} @else {
  <ng-content />
}
